export const AMOUNTS_COLUMNS = 3;
